import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import LandingPage from './LandingPage.jsx'
import ArenaPK from './ArenaPK.jsx'
import { auth } from './firebase'
import ChampionsPK from './ChampionsPK';
import LigaPK from './LigaPK';
import { instalarDiagnostico } from './diagnostico';
import ErrorBoundary from './ErrorBoundary.jsx';
import { registarTrabalhador } from './registarTrabalhador';

// Publica gfl.limpo() na consola, para a verificação manual conseguir medir
// se sobrou alguma câmara acesa ou algum listener por desligar. Só lê.
instalarDiagnostico();

// O trabalhador do estádio (notificações + rede). Um só, registado num só
// sítio — ver src/registarTrabalhador.js.
registarTrabalhador();

const root = createRoot(document.getElementById('root'));

// ECRÃ DE ARRANQUE: fica no ar enquanto o Firebase restaura a sessão. Sem ele,
// a app desenhava a LandingPage com o utilizador ainda a null e quem já estava
// autenticado via o "ENTRAR NO ESTÁDIO" outra vez.
function ecraDeArranque() {
  return (
    <div style={{
      background: '#000', height: '100dvh', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      color: '#39FF14', fontWeight: 'bold', fontSize: '20px',
    }}>
      GAME FUT LIVE...
    </div>
  );
}

function desenhar(user) {
  const urlParams = new URLSearchParams(window.location.search);
  const naArena = urlParams.has('arena');
  const naChampions = urlParams.has('champions');
  const naLigaPK = urlParams.has('ligapk');
  const naApp = urlParams.has('app');
  const modoPWA = window.matchMedia('(display-mode: standalone)').matches;

  // `naLigaPK` faltava aqui. Resultado: o botão LIGA PK do menu do perfil
  // levava a "?ligapk", e como a Liga não contava para esta condição, quem
  // ainda não tivesse a sessão resolvida caía na LandingPage.
  const querUmEcraDaApp = naApp || naArena || naChampions || naLigaPK || modoPWA;

  // Tudo o que vai para o ecrã passa pela rede de segurança. Sem ela, um erro
  // dentro de qualquer ecrã desmontava a árvore toda e o utilizador ficava a
  // olhar para o fundo preto do <body> — o famoso "ecrã preto" do iPhone.
  const comRede = (elemento, nomeDoEcra) => (
    <StrictMode>
      <ErrorBoundary ecra={nomeDoEcra}>{elemento}</ErrorBoundary>
    </StrictMode>
  );

  if (user || querUmEcraDaApp) {
    if (naArena) {
      root.render(comRede(<ArenaPK />, 'arena'));
    } else if (naChampions) {
      root.render(comRede(<ChampionsPK />, 'champions'));
    } else if (naLigaPK) {
      root.render(comRede(<LigaPK />, 'ligapk'));
    } else {
      root.render(comRede(<App />, 'app'));
    }
  } else {
    // SÓ mostra o site para quem é novo e entra pelo link puro
    root.render(comRede(<LandingPage />, 'landing'));
  }
}

root.render(ecraDeArranque());

// authStateReady() só resolve DEPOIS de o Firebase ler a sessão guardada. É a
// diferença entre "não há utilizador" e "ainda não sabemos" — e era essa
// confusão que mandava toda a gente de volta ao ecrã de entrada.
const sessaoPronta = typeof auth.authStateReady === 'function'
  ? auth.authStateReady()
  : Promise.resolve();

sessaoPronta
  .catch((erro) => console.warn('Não foi possível restaurar a sessão:', erro))
  .then(() => {
    desenhar(auth.currentUser);
    auth.onAuthStateChanged(desenhar);
  });
